<template>
  <svg :width="width" :height="height" viewBox="0 0 77 59" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.5 14C10.5421 14 6.3162e-05 23.5621 6.3162e-05 35.3158C6.3162e-05 39.425 1.29021 43.4047 3.73499 46.8453C3.27204 52.0061 2.03124 55.8374 0.22958 57.6524C-0.00855349 57.8924 -0.0680868 58.2595 0.082313 58.5626C0.216263 58.8334 0.489646 59 0.783395 59C0.819429 59 0.856245 58.9976 0.893062 58.9921C1.21031 58.9471 8.5799 57.8774 13.9097 54.7779C16.9373 56.0087 20.1615 56.6316 23.5 56.6316C36.4579 56.6316 47 47.0695 47 35.3158C47 23.5621 36.4579 14 23.5 14Z" fill="#80B7FF"/>
    <path d="M72.9 47.5393C74.0413 48.6896 74.3256 50.4403 73.6067 51.8928C72.965 53.1899 71.6472 54 70.2166 54C70.0549 54 69.8737 53.9897 69.6785 53.9614C69.3003 53.9076 62.5164 52.9296 56.8657 50.0674C53.8716 51.1082 50.7266 51.6316 47.5 51.6316C33.1673 51.6316 21 40.995 21 27.3158C21 13.6366 33.1673 3 47.5 3C61.8326 3 73.9999 13.6366 73.9999 27.3158C73.9999 31.6837 72.7362 35.9108 70.3602 39.6205C70.5885 41.584 70.9377 43.2466 71.3694 44.5782C71.8888 46.18 72.4613 47.0974 72.8995 47.5389L72.9 47.5393Z" fill="#80B7FF" stroke="white" stroke-width="6"/>
  </svg>

</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.iconColor }
  },
  name: "IconChoiseChat"
}
</script>